import React from 'react';
import { TableCell, TableRow } from '@/components/ui/table';
import { getFieldsForTipo } from '@/lib/inventario/fieldSchemas';

interface Props {
  elemento: any;
  colSpan: number;
}

/**
 * Sub-fila expandible: muestra los datos técnicos específicos del tipo,
 * además de campos comunes que no aparecen en la cabecera de la tabla.
 */
export const ElementoDetalleFila: React.FC<Props> = ({ elemento, colSpan }) => {
  const fields = getFieldsForTipo(elemento?.tipo);
  const datos = (elemento?.datos_tecnicos ?? {}) as Record<string, any>;

  const entradasTecnicas = fields
    .map((f) => ({ label: f.label, value: datos[f.key] }))
    .filter((e) => e.value !== undefined && e.value !== null && e.value !== '' && e.value !== false);

  const comunes: { label: string; value: any }[] = [
    { label: 'Nº serie / MAC', value: elemento.mac_serie },
    { label: 'Año fabricación', value: elemento.anio_fabricacion },
    { label: 'Fecha instalación', value: elemento.fecha_instalacion ? new Date(elemento.fecha_instalacion).toLocaleDateString() : null },
    { label: 'Observaciones', value: elemento.observaciones },
  ].filter((e) => e.value);

  const todas = [...comunes, ...entradasTecnicas];

  return (
    <TableRow className="bg-muted/20 hover:bg-muted/30">
      <TableCell colSpan={colSpan} className="p-4">
        {todas.length === 0 ? (
          <p className="text-sm text-muted-foreground italic">Sin datos técnicos adicionales.</p>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-6 gap-y-2">
            {todas.map((e, idx) => (
              <div key={idx} className="flex flex-col text-sm">
                <span className="text-xs uppercase tracking-wide text-muted-foreground">{e.label}</span>
                <span className="font-medium text-foreground break-words">
                  {typeof e.value === 'boolean' ? (e.value ? 'Sí' : 'No') : String(e.value)}
                </span>
              </div>
            ))}
          </div>
        )}
      </TableCell>
    </TableRow>
  );
};
